import { devices } from "src/utils/styled/_variables.styled";
import styled from "styled-components";

export const CardIconContainer = styled.section`
	height: 100%;
	.card-container {
		background-color: #f5f5f5 !important;
		box-sizing: border-box !important;
		border-radius: 16px !important;
		padding: 24px !important;
		width: 100% !important;
		height: 100%;

		div[data-testid="rango-icon"] {
			margin-right: 10px !important;
		}

		@media ${devices.onlyTablet} {
			width: 100% !important;
		}

		@media ${devices.mobile} {
			width: 100% !important;
		}
	}
`;
